export default __webpack_public_path__ + "static/media/idea-web-4.3dfd2f83.png";